import React, { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import api from "../lib/api";

/**
 * LegalSignoff — renders the reviewed/effective-date + version sign-off block
 * for a legal page (privacy | cookies | terms). Content is owner-managed from
 * the admin "Site content" panel; falls back to seeded defaults.
 */
export const LegalSignoff = ({ page }) => {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    let live = true;
    api.get("/content/legal")
      .then(({ data }) => { if (live) setMeta((data.legal || {})[page] || null); })
      .catch(() => {});
    return () => { live = false; };
  }, [page]);

  if (!meta) return null;

  return (
    <div
      className="mt-8 border border-zinc-200 bg-zinc-50 px-5 py-4 flex items-start gap-3"
      data-testid={`legal-signoff-${page}`}
    >
      <ShieldCheck size={18} strokeWidth={1.8} className="mt-0.5 flex-none text-[#7737F6]" />
      <div className="text-[13px] leading-relaxed text-zinc-700">
        <div className="text-[11px] font-medium tracking-[0.18em] uppercase text-zinc-500">Document control</div>
        <div className="mt-1.5 flex flex-wrap gap-x-6 gap-y-1">
          {meta.version && (
            <span data-testid={`legal-version-${page}`}><span className="text-zinc-500">Version</span> <strong className="font-semibold text-black">{meta.version}</strong></span>
          )}
          {meta.effective_date && (
            <span data-testid={`legal-effective-${page}`}><span className="text-zinc-500">Effective</span> <strong className="font-semibold text-black">{meta.effective_date}</strong></span>
          )}
          {meta.reviewed_date && (
            <span data-testid={`legal-reviewed-${page}`}><span className="text-zinc-500">Last reviewed</span> <strong className="font-semibold text-black">{meta.reviewed_date}</strong></span>
          )}
          {meta.reviewed_by && (
            <span data-testid={`legal-reviewedby-${page}`}><span className="text-zinc-500">Reviewed by</span> <strong className="font-semibold text-black">{meta.reviewed_by}</strong></span>
          )}
        </div>
      </div>
    </div>
  );
};

export default LegalSignoff;
